<template>
    <div class="topbar">

        <div class="topbar-item">
            <b-dropdown no-caret no-flip right size="sm"
                        toggle-class="btn btn-icon btn-hover-transparent-white d-flex align-items-center btn-lg px-md-2 w-md-auto"
                        variant="link">
                <template v-slot:button-content>
                    <img :src="languageFlag || getLanguageFlag" alt="" class="h-20px w-20px rounded-sm"/>
                </template>
                <b-dropdown-text class="min-w-md-175px" tag="div">
                    <KTDropdownLanguage v-on:language-changed="onLanguageChanged"></KTDropdownLanguage>
                </b-dropdown-text>
            </b-dropdown>
        </div>

        <KTQuickUser></KTQuickUser>

    </div>
</template>

<script>

   import KTDropdownLanguage from "@/view/layout/extras/dropdown/DropdownLanguage.vue";
   import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
   import i18nService from "@/core/services/i18n.service.js";

   export default {
      name: "KTTopbar",
      data() {
         return {
            languageFlag: "",
            languages: i18nService.languages
         };
      },
      components: {
         KTDropdownLanguage,
         KTQuickUser,
      },
      methods: {
         onLanguageChanged() {
            this.languageFlag = this.languages.find(val => {
               return val.lang === i18nService.getActiveLanguage();
            }).flag;
         }
      },
      computed: {
         getLanguageFlag() {
            return this.onLanguageChanged();
         }
      }
   };
</script>

<style lang="scss">
    .topbar {
        .dropdown-toggle {
            padding: 0;

            &:hover {
                text-decoration: none;
            }

            &.dropdown-toggle-no-caret {
                &:after {
                    content: none;
                }
            }
        }

        .dropdown-menu {
            margin: 0;
            padding: 0;
            outline: none;

            .b-dropdown-text {
                padding: 0;
            }
        }
    }
</style>